import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const ShowMore = styled.button`
  background: none;
  border: none;
  font-weight: 600;
  line-height: 1.43;
  color: ${ColorPalette.HEX.OriolesOrange};
  height: 70px;
  width: 100%;
  cursor: pointer;
`;
